export class User {
	public id!: string;
	public adresseCourriel!: string;
	public idAgence!: string;
	public idFranchise!: string;
	public prenom!: string;
	public nom!: string;
	public niveauDroits!: string;
}
